import React, { Component, Fragment} from 'react'
import Breadcrumb from "../../common/breadcrumb"
import Modal from 'react-responsive-modal';
import 'react-toastify/dist/ReactToastify.css';
import Datatable from '../../common/datatable'
import {Link} from 'react-router-dom'
import { getObjects, updateObject, deleteObject, stopTimer } from  "../../api";

export class LandingPageList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            loading: true, // set to false once loading is completed
            editingRow: {},
            actionMode: ''
        };
    }

    onOpenModal = () => {
        this.setState({ editingRow: {}, actionMode: 'new', open: true });
    };

    onCloseModal = (mode) => {
        this.setState({ open: false });
        if(mode === true)
        {
            if (document.getElementById("newLandingPage").elements['actionMode'].value === 'new') {
                this.onCreateLandingPage(document.getElementById("newLandingPage").elements['landingPageName'].value);
            } else if (document.getElementById("newLandingPage").elements['actionMode'].value === 'update') {
                this.onUpdateLandingPage(  document.getElementById("newLandingPage").elements['itemId'].value,
                                        document.getElementById("newLandingPage").elements['landingPageName'].value);
            } else {
                this.onDeleteLandingPage(  document.getElementById("newLandingPage").elements['itemId'].value);
            }
        } else {
            console.log('cancel');
        }
    };

    onItemEdit = (row) => {
        this.props.history.push(`/admin/landingPage/edit?pid=${row._id}`)
    };

    onItemDelete = (row) => {
        this.setState({editingRow: row, actionMode: 'delete', open: true });        
    };

    onCreateLandingPage = (name) => {
        updateObject('landingPage', { "name": name }).then(d2 => {
            if (d2.error) {
                console.log(d2.error);
            } else {
                this.loadLandingPages();
            }
        });
    };

    onUpdateLandingPage = (id, name) => {
        updateObject('landingPage', { "name": name }, id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.loadLandingPages();
                }
            }
        );
    };

    onDeleteLandingPage = (id) => {
        deleteObject('landingPage', id).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadLandingPages();
            }
        });
    };

    loadLandingPages = () => {
        this.setState({ loading: true});
        getObjects('landingPage').then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ data: d2, loading: false});
            }
        });
    };

    componentDidMount(){
        this.loadLandingPages();
    }

    render() {
        const { open } = this.state;

        if (this.state.loading) { return null; }
        else {
            stopTimer();       
      
        return (
            <Fragment>
                <Breadcrumb title="LandingPage List" />
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="btn-popup pull-right">
                                        <Link to="/admin/landingPage/edit">
                                            <button type="button" className="btn btn-primary">Add Landing Page</button>  
                                        </Link> 
                                        <Modal open={open} onClose={this.onCloseModal} >
                                            <div className="modal-header">
                                                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                                                {this.state.actionMode==='delete'?'Delete ':this.state.actionMode==='update'?'Update ':'Add '}
                                                LandingPage</h5>
                                            </div>
                                            <div className="modal-body">
                                                <form id="newLandingPage">
                                                    <input type="hidden" id="itemId" value={this.state.editingRow._id?this.state.editingRow._id:''} />
                                                    <input type="hidden" id="actionMode" value={this.state.actionMode} />
                                                    <div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >LandingPage Title :</label>
                                                        <input id="landingPageTitle" defaultValue={this.state.editingRow.title?this.state.editingRow.title:''} type="text" className="form-control" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="message-text" className="col-form-label">LandingPage Image :</label>
                                                        <input className="form-control" id="validationCustom02" type="file" />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true)}>{this.state.actionMode==='delete'?'Delete':'Save'}</button>
                                                <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Close</button>
                                            </div>
                                        </Modal>
                                    </div>
                                    <div className="clearfix"></div>
                                    <Datatable
                                        multiSelectOption={false}
                                        myData={this.state.data} 
                                        columns={['imageUrl', 'title', 'status', 'publishedAt']}
                                        imageUrlField='imageUrl'
                                        thumbRatio={385/1370}
                                        pageSize={100} 
                                        pagination={true}
                                        onItemDelete={this.onItemDelete}
                                        onItemEdit={this.onItemEdit}
                                        class="-striped -highlight" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
            </Fragment>
        )
    }
    }
}

export default LandingPageList

